import { BRAND } from '@archetelos/ui';
import { Link } from '@tanstack/react-router';

import type { ReactNode } from 'react';

import { Logo } from '@/components/brand/Logo';

interface AuthLayoutProps {
  title: string;
  subtitle?: string;
  children: ReactNode;
}

export function AuthLayout({ title, subtitle, children }: AuthLayoutProps) {
  const marketingUrl = import.meta.env.PUBLIC_MARKETING_URL ?? `https://${BRAND.domain}`;
  return (
    <div className="min-h-screen bg-parchment text-ink">
      <header className="px-6 py-6">
        <Link to="/" aria-label={BRAND.name} className="inline-block">
          <Logo className="h-9 w-auto" />
        </Link>
      </header>
      <main className="flex min-h-[calc(100vh-8rem)] items-center justify-center px-6 py-8">
        <div className="w-full max-w-md">
          <div className="rounded-lg border border-ink/10 bg-parchment p-8 shadow-sm">
            <h1 className="font-serif text-2xl text-ink sm:text-3xl">{title}</h1>
            {subtitle && <p className="mt-2 font-sans text-sm text-ink/70 pretty">{subtitle}</p>}
            <div className="mt-8">{children}</div>
          </div>
        </div>
      </main>
      <footer className="px-6 py-6 text-center">
        <a
          href={marketingUrl}
          className="font-sans text-xs uppercase tracking-[0.12em] text-ink/50 hover:text-oxblood"
        >
          ← Back to {BRAND.domain}
        </a>
      </footer>
    </div>
  );
}
